/**
 * Theme toggle (prompt.md §40, §44).
 *
 * A single accessible control shared by web and desktop, so the two clients
 * cannot drift on the label, the icon affordance or the accessible name. It is
 * presentational: the caller owns the scheme and its persistence, which keeps
 * this component usable inside a test without a browser.
 */

import { Button } from "../primitives/Button.tsx";
import type { ThemeScheme } from "./Theme.tsx";

export interface ThemeToggleProps {
  readonly scheme: ThemeScheme;
  readonly onChange: (next: ThemeScheme) => void;
}

export function ThemeToggle({ scheme, onChange }: ThemeToggleProps) {
  const next: ThemeScheme = scheme === "dark" ? "light" : "dark";
  return (
    <Button
      size="sm"
      variant="ghost"
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
      onClick={() => onChange(next)}
    >
      {scheme === "dark" ? "Light theme" : "Dark theme"}
    </Button>
  );
}
